// extracted by mini-css-extract-plugin
export default {"progressWrapper":"ProgressSteps_progressWrapper__ybh2U","progressItem":"ProgressSteps_progressItem__ofmMo"};